import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import Button from '../components/Button'
import FullPageCenterItems from "../components/FullPageCenterItems"
import Spinner from "../components/Spinner"
import { useFetch } from "../lib/fetch"
import { getAuthorizationTokens, useLoadingMessage } from '../lib/utils'

export const StoreContext = createContext()
export const useStore = () => useContext(StoreContext)

export function StoreProvider(props) {
    // const { authenticatedUser } = useAuth()
    const [payWithPlanCode, setPayWithPlanCode] = useState(null)
    const [currentUser, setCurrentUser] = useState({ id: 24679538, email: 'user@email.com', customer_code: 'CUS_rztj7mm74hl7p2r' })
    const { id, email, customer_code } = currentUser

    // Fetch data
    const loadingMessage = useLoadingMessage()
    const { status: status2, data: allCustomers, refetch: refetch2 } = useFetch({ key: 'all-customers', url: `customers` })
    const { status, data, error, refetch } = useFetch({
        key: "all-data", strict: true,
        url: `transactions/customer/totals?customer=${id}&customer_email=${email}&customer_code=${customer_code}`,
    })

    const isLoading = status === "loading" || status2 === "loading"
    const refetchAll = useCallback(() => [refetch, refetch2].forEach(cb => cb()), [refetch, refetch2])

    // Get transactions and find active customer and authorizations
    const { investment, liquidation, interest, startDate, balance, data: transactions } = data
    const customer = allCustomers.data?.find(cus => cus.customer_code === customer_code) //have to refactor this
    const authorizedCards = transactions.length ? getAuthorizationTokens(transactions, email) : []

    useEffect(() => {
        refetchAll()
    }, [id, refetchAll])

    return (
        <StoreContext.Provider value={{
            currentUser,
            setCurrentUser,
            user: customer,
            transactions,
            authorizedCards,
            investmentData: {
                investment,
                liquidation,
                interest,
                balance,
                startDate
            },
            allCustomers: allCustomers.data,
            payWithPlanCode, setPayWithPlanCode
        }}>
            {
                isLoading ?
                    <FullPageCenterItems fullscreen>
                        <Spinner />
                        <p className="block text-md text-gray-500 mt-4">{loadingMessage}</p>
                    </FullPageCenterItems>
                    : error ?
                        <FullPageCenterItems fullscreen>
                            <p className="text-center text-gray-800">
                                There was an error
                                <span className="text-gray-500 block mt-2 mb-2">{error.message}</span>
                            </p>
                            <Button variant="light-blue" onClick={refetchAll}>Retry</Button>
                        </FullPageCenterItems>

                        : props.children
            }
        </StoreContext.Provider>
    )
}